'use strict'

import 'jquery-cycle';
import 'jquery.easing';
import Swiper from 'swiper/bundle';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/pagination';
import * as utils from "./products/product-utils";

export default function () {
    var isLoggedIn = document.body.classList.contains("loggedIn");

    var brands = document.querySelector('[js-hook-brands]');
    if (brands !== null) {
        var container = brands.querySelector('.swiper');
        const brandsSwiper = new Swiper(container, {
            modules: [Navigation],
            direction: 'horizontal',
            slidesPerView: 8,
            spaceBetween: 10,
            loop: true,
            lazyLoading: false,
            keyboard: {
                enabled: true
            },
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 4
                },
                1200: {
                    slidesPerView: 8
                }
            },
            centerInsufficientSlides: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                enabled: false
            },
            navigation: {
                nextEl: '#nextBrand',
                prevEl: '#prevBrand',
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                enabled: false
            },
        });
    }

    if (isLoggedIn) {
        utils.productPricing();
    }
}